// this is an autogenerated file from App/Widget/Content/Questions/Complete/MedicalForm/Content/MedicalFormUrl/data.graphql
import { gql } from 'Data/Api'

export default gql`
subscription app__App_Widget_Content_Questions_Complete_MedicalForm_Content_MedicalFormUrl($id: uuid!) {
  lead: leads_leads(where: { id: { _eq: $id } }) {
    id
    patient_id
  }
}

`